import ServicePath from "@/core/ServicePath";
import { MainRequest } from "@/core/request";

export default class MedicalPracticeRequest extends MainRequest {
  
  static get(data) {
    return this.postSEC(ServicePath.MEDICAL_PRACTICE_LIST_BY_ID, data);
  }

  static listAllHistory(data) {
    return this.postSEC(
      ServicePath.MEDICAL_PRACTICE_BY_STATUS_AND_SPECIALITY,
      data
    );
  }

  static getDentalAppointment(data){
    return this.postSEC(ServicePath.PROCEDURE_APPLICATION_LIST_BY_MEDICAL, data)
}

static update(params) {
  return this.postSEC(ServicePath.PROCEDURE_APPLICATION_UPDATE, params);
}
}
